import { Box, Tabs, Tab, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { showError } from '../../constants/toasts';
import BasicInformation from '../../features/vehicleDetail/basicInformation';
import ImageGallery from '../../features/vehicleDetail/imageGallery';
import VehicleTop from '../../features/vehicleDetail/vehicleTop';
import MainContainer from '../../layout/MainContainer';
import { useLazyGetListingByIdQuery } from '../../service/listing';
import { ListingById } from '../../types/General';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const VehicleDetail = () => {
  const navigate = useNavigate();
  const { type, id } = useParams();
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState<ListingById>();
  const [getDetail] = useLazyGetListingByIdQuery();

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const getListingDetail = async (id: string) => {
    setLoading(true);
    try {
      const response = await getDetail({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setDetails(response?.data);
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      getListingDetail(id);
    }
  }, []);

  return (
    <MainContainer>
      <div className="main_title fdx">
        <div>
          <h1>Vehicle Detail</h1>
          <p>
            <span onClick={() => navigate('/dashboard')}>Dashboard</span> - Listings - Vehicle
            Detail
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_orange" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <VehicleTop type={type} details={details} />

      <Box className="custom_tabs2" sx={{ width: '100%' }}>
        <Tabs
          value={valueTabs}
          onChange={handleChangeTabs}
          aria-label="basic tabs example"
          className="custom_tabs_links"
        >
          <Tab label="Basic Information" {...a11yProps(0)} />
          <Tab label="Image Gallery" {...a11yProps(1)} />
          {/* <Tab label="Ratings and Reviews" {...a11yProps(2)} /> */}
        </Tabs>
      </Box>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <BasicInformation type={type} details={details} />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <ImageGallery details={details} />
        </CustomTabPanel>
      </div>
    </MainContainer>
  );
};

export default VehicleDetail;
